module.exports = __webpack_public_path__ + "img/cpa.ad361829.png";